import { render, staticRenderFns } from "./ConstructionPeriodsViewer.vue?vue&type=template&id=b8913b6e&scoped=true&lang=pug"
import script from "./ConstructionPeriodsViewer.vue?vue&type=script&lang=js"
export * from "./ConstructionPeriodsViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8913b6e",
  null
  
)

export default component.exports